import { AccountModel } from 'data-ng-authentication';
import { UserModesService } from '../../../user_modes/user_modes_service';

export class MicroNavAp3Controller {
  constructor(public accountModel: AccountModel, public ngUserModesService: UserModesService) {}
  isAdvisor() {
    return this.ngUserModesService.isAdvisorOnly;
  }
}

export class SGDAp3Controller {
  constructor(public ngUserModesService: UserModesService) {}
  isAdvisor() {
    return this.ngUserModesService.isAdvisorOnly;
  }
  $onInit() {
    if (this.isAdvisor()) {
      window.location.assign('#/my/ap3/advisor/');
    } else {
      window.location.assign('#/my/ap3/student/');
    }
  }
}

export const MicroNavAp3Directive = {
  restrict: 'E',
  replace: false,
  // we want to pollute the scope to save the micro and shut it down on element.destroy
  //
  scope: true,
  controller: 'MicroNavAp3Controller',
  link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: unknown, controller: MicroNavAp3Controller) {
    const studentNk = window.sessionStorage.getItem('external_id');
    const appEl = element[0];
    const { accountModel } = controller;

    const hasUserLoggedIn = accountModel.id > 0;
    if (!hasUserLoggedIn) {
      return;
    }
    window['$ip']
      .requires([
        './64b49d3c3fffee0b/micros/nav/ap3/bin/index.js?resource_type=module',
        './64b49d3c3fffee0b/micros/nav/ap3/bin/index.css'
      ])
      .then(([microDelegate]: [any]) => {
        const advisorAccountOptions = {
          student_nk: studentNk,
          user_mode: 'advisor'
        };

        const studentAccountOptions = {
          user_mode: 'student'
        };

        const isAdvisor = controller.isAdvisor();

        const authorizationType = isAdvisor ? 'digest' : 'csrf';
        const accountOptions = isAdvisor ? advisorAccountOptions : studentAccountOptions;

        scope.microDelegate = microDelegate;

        return microDelegate.startup(appEl, {
          routes: {
            uri: '/my/ap3'
          },
          view: {
            configuration: {
              account: accountOptions,
              endpoints: {
                host: {
                  application_name: 'sgd',
                  server: '/'
                },
                authorization: {
                  type: authorizationType,
                  token: accountModel.token
                }
              }
            }
          }
        });
      });
    scope.$on('$destroy', () => {
      if (scope.microDelegate) {
        scope.microDelegate.shutdown();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./app/lib/ap3/components/ap3/ap3.ts